export const __TEST__ = process.env.NODE_ENV === "test";

export const __DEV__ = process.env.NODE_ENV === "development";
